module.exports = __webpack_public_path__ + "static/media/logo-600x180.96a0621a.png";